import { render } from "./BookmarkMobile.vue?vue&type=template&id=71204634&scoped=true"
import script from "./BookmarkMobile.vue?vue&type=script&lang=js"
export * from "./BookmarkMobile.vue?vue&type=script&lang=js"

import "./BookmarkMobile.vue?vue&type=style&index=0&id=71204634&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71204634"]])

export default __exports__